import React from "react";
import { IHeaderContext } from "./HeaderContext.types";

const HeaderContext = React.createContext<IHeaderContext>({
  setHeaderTitle: (title: string) => {},
  headerTitle: "",
  currentUserId: "",
  roles: [],
});

export default HeaderContext;
